import { render, staticRenderFns } from "./UploadImagesDropdownItem.vue?vue&type=template&id=16e2b874&scoped=true"
import script from "./UploadImagesDropdownItem.vue?vue&type=script&lang=js"
export * from "./UploadImagesDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2b874",
  null
  
)

export default component.exports